import React from 'react';

const SvgPhone = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    width={props.width || 25}
    height={props.height || 24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2822_7579)">
      <path
        d="M23.6716 16.9646L18.4448 14.7129C18.2212 14.6177 17.973 14.5971 17.7368 14.6541C17.5006 14.7111 17.2891 14.8427 17.1336 15.0294L14.8276 17.8779C11.176 16.1574 8.23762 13.219 6.51714 9.56743L9.32045 7.23435C9.50988 7.08089 9.64413 6.86987 9.70287 6.63327C9.76162 6.39666 9.74165 6.14736 9.646 5.92312L7.39431 0.678207C7.29402 0.432339 7.11037 0.229626 6.87557 0.105613C6.64078 -0.0183995 6.36982 -0.0557945 6.11021 -1.44094e-05L1.26318 1.15748C1.00936 1.20755 0.780662 1.34385 0.61585 1.54327C0.451039 1.7427 0.360255 1.99297 0.358887 2.25168C0.370862 8.01185 2.66748 13.532 6.74478 17.6008C10.8221 21.6697 16.347 23.9548 22.1072 23.9548C22.367 23.9538 22.6185 23.8633 22.8195 23.6986C23.0204 23.5339 23.1585 23.305 23.2104 23.0505L24.3318 18.1763C24.3893 17.9176 24.3548 17.647 24.2343 17.411C24.1138 17.175 23.9149 16.9883 23.6716 16.8832V16.9646Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2822_7579">
        <rect width={24} height={24} fill="currentColor" transform="translate(0.358887)" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPhone;
